module.exports = __webpack_public_path__ + "img/bgc.f6bbd905.png";